import React, { useEffect, useContext, useState } from "react";
import { Prompt } from 'react-router-dom'
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { Grid, PageContainer } from 'layouts';
import { ProductsContext, AuthContext, ValuesContext } from 'contexts';
import { Button, DnDList } from 'components';
import ValuesFilter from "./ValuesFilter";

const useStyles = makeStyles((theme) => ({
  selectCategoryMsgGrid: {
    justifyContent: 'center',
    display: 'flex'
  },
  selectCategoryMsgContent: {
    marginTop: '16px',
    color: 'rgba(0, 0, 0, 0.38)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.15px',
    lineHeight: '21px'
  },
  controls: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginBottom: '32px'
  },
  resetBtn: {
    marginRight: '16px'
  }
}));

export default () => {
  const classes = useStyles();
  const { state: productsState, actions: productsActions } = useContext(ProductsContext);
  const { state: authState } = useContext(AuthContext);
  const { state: valuesState, actions: valuesActions } = useContext(ValuesContext);
  const [cards, setCards] = useState([]);

  useEffect(() => {
    if (!productsState.products.length) {
      productsActions.getProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!valuesState.values.length) {
      valuesActions.fetchAllValues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!productsState.productsFilters) {
      productsActions.getFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderContentStub = () => {
    return (
      <span className={classes.selectCategoryMsgContent}>
        Please select a Business Unit, Category and Refiner to see Values.
      </span>
    );
  }

  const isValueUsed = (businessUnit, category, specifier, value) => {
    return productsState.products
      .find(p => p.business_unit === businessUnit
        && p.category === category
        && String(p.specifications?.[specifier]) === value);
  }

  const renderContent = ({ businessUnit, category, specifier }) => {
    const orderUnchanged = _.isEqual(cards,
      valuesActions.getValues(businessUnit, category, specifier));
    window.onbeforeunload = orderUnchanged ? null : () => '';

    return (
      <div>
        <Prompt
          when={!orderUnchanged}
          message='You have unsaved changes, are you sure you want to leave?'
        />
        <div className={classes.controls}>
          <Button
            variant="contained"
            color="primary"
            disabled={orderUnchanged}
            onClick={async () => {
              await valuesActions.updateValues(businessUnit, category, specifier, cards);
              await valuesActions.fetchAllValues();
            }}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={orderUnchanged}
            className={classes.resetBtn}
            onClick={() => {
              setCards(valuesActions.getValues(businessUnit, category, specifier));
            }}
          >
            Reset
          </Button>
        </div>
        <DnDList
          cards={cards}
          setCards={setCards}
          isValueUsed={
            (value) => isValueUsed(businessUnit, category, specifier, value)
          }
        />
      </div>
    );
  }

  const renderContentHelper = ({ businessUnit, category, specifier }) => {
    if (businessUnit && category && specifier)
      return renderContent({ businessUnit, category, specifier });
    return renderContentStub();
  };

  const onSubmit = ({ businessUnit, category, specifier }) => {
    if (businessUnit && category && specifier)
      setCards(valuesActions.getValues(businessUnit, category, specifier));
  };

  return (
    <PageContainer component="main" maxWidth="md">
      <Formik
        initialValues={{
          businessUnit: '',
          category: '',
          specifier: ''
        }}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Grid container>
            <Grid item xs={4}>
              <ValuesFilter
                productsFilters={productsState.productsFilters}
                roles={authState.roles}
                {...props}
              />
            </Grid>
            <Grid className={classes.selectCategoryMsgGrid} item xs={8}>
              {
                renderContentHelper(props.values)
              }
            </Grid>
          </Grid>
        )}
      </Formik>
    </PageContainer>
  );
}